import React, { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import NavBar from '../copmponents/NavBar'
import UserProfile from '../copmponents/UserProfile'
import RequiredFieldsGate from '../copmponents/RequiredFieldsGate';
import { UserProvider } from '../copmponents/UserProvider';
// import PremiumPopup from '../copmponents/PremiumPopup';

const Mobile = () => {
  const [loading, setLoading] = useState(false)
  // const [enter, setEnter] = useState(true)
  setTimeout(() => { setLoading(true) }, 1000)
  // const navigate = useNavigate();

  // useEffect(() => {
  //   const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  //   if (!isMobile) {
  //     navigate("/");  // אם המשתמש לא במובייל, להפנות אותו לדף הרגיל
  //   }
  // }, [navigate]);
  return (
    // <div className='h-svh p-4 pb-16'>
    //   {loading&&<UserProfile/>}
    //        <Outlet/>
    //     <NavBar/>
    //     </div>
     <RequiredFieldsGate>
    <div className="h-svh flex flex-col">
      {/* {enter && <PremiumPopup show={true} 
      onClose={() => setEnter(false)} 
      />} */}
<UserProvider>
      {/* חלק עליון - פרופיל (קבוע) */}
      <div className="p-2 bg-white shadow-md">
        <UserProfile />
      </div>

      {/* חלק אמצעי - תוכן משתנה */}
      <div className="flex-grow overflow-auto mt-2 pb-20 p-4">
        <Outlet />
      </div>
      </UserProvider>

      {/* חלק תחתון - ניווט (קבוע) */}
      <div className=" fixed bottom-0 left-0 w-full bg-white shadow-lg">
        <NavBar />
      </div>
    </div>
    </RequiredFieldsGate>

  )
}

export default Mobile